import { DoubleRightOutlined } from '@ant-design/icons';
import { PageHeader as AntPageHeader } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { useResponsive } from '@/contexts/ResponsiveContext';

import style from './index.less';

// eslint-disable-next-line react/prop-types
const itemRender = ({ path, breadcrumbName }) => (<Link to={path}>
  {breadcrumbName}
</Link>);

const PageHeader = ({ title, customMap, className, ...props }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation('navigation');
  const { isMobile } = useResponsive();
  const pathSnippets = pathname.split('/').filter(i => i);
  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    let title = '';
    if (url.endsWith('create')) {
      title = 'create';
    }
    if (url.endsWith('edit')) {
      title = 'edit';
    }
    return {
      path: url,
      breadcrumbName: (customMap && customMap[url]) || t(title || url),
    };
  });
  
  const routes = [
    {
      path: '/',
      breadcrumbName: t('home')
    }
  ].concat(extraBreadcrumbItems);
  
  return (
    <div className="page-header">
      <AntPageHeader
        ghost={false}
        className={classNames(style.withOutPadding, { [style.noTitle]: !title }, { 'truncate': isMobile }, className)}
        title={title}
        breadcrumb={{ routes, itemRender, separator: <DoubleRightOutlined className="opacity-50"/> }}
        {...props}
      />
    </div>
  );
  
};

export default memo(PageHeader);

PageHeader.propTypes = {
  className: PropTypes.string,
  customMap: PropTypes.object,
  title: PropTypes.any
};
